import { BaseComponent } from '../../../../components/BaseComponent';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VBox } from '../../../../components/Box';
import { UserSelection } from '../../../Users/components/UserSelection';
import { Button } from '../../../../components/Buttons';
import { WithCompany } from '../../../Companies/components/WithCompany';
import { Well } from '../../../../components/Well';
import { CompanyLabel } from '../../../Companies/components/CompanyLabel';
import { UserLabelById } from '../../../Users/components/UserLabelById';
import { EditSquare } from '../../../../components/Icon';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import React from 'react';
import { Loader } from '../../../../components/Loader';
import { VehicleCreateFieldCompanyUser } from '../../../Vehicles/pages/create/FieldCompanyUser';
import { updateInvoice } from '../../actions';
import { fetchUser } from '../../../Users/actions';
import { selectWork } from '../../../Api/selectors';
import { REQUEST_USER } from '../../../Users/constants';
import { INVOICE_DIRECTIONS } from '../../../Invoices/constants';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import styles from './UpdateInvoiceEmailModal.module.css';

const Container = styled.div`
  .button-sync {
    margin: 0px;
  }
  visibility: ${props => (props.customerModal ? 'hidden' : '')};

  .message {
    max-width: 400px;
    margin: 10px 0;
  }
`;

const STATE = {
  selectUser: false,
  financialContact: null,
  emailContact: null,
  showCustomerModal: false,
};

/* eslint-disable react/prefer-stateless-function */
class UpdateInvoiceEmailModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.invoice?.financialContactId) {
      this.props.fetchUser(this.props.invoice?.financialContactId, res => {
        if (res?.id) {
          this.setState({ financialContact: res?.id });
        }
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState?.financialContact != this.state.financialContact) {
      this.props.fetchUser(this.state.financialContact, res => {});
    }
  }

  get invoice() {
    return this.props.invoice;
  }

  selectUser(user) {
    this.setState({ emailContact: user });
    this.reset();
  }

  reset() {
    this.setState({ selectUser: false, addUser: null });
  }

  onResetValues() {
    [
      'client',
      'email_contact',
      'financial_contact',
      'includeEmailContact',
      'includeFinancialContact',
      'includeManual',
      'outgoingCompanyId',
      'send_to_email',
    ].map(type => this.props.setValue('', type));
    return this.props.reset();
  }

  get financialContact() {
    return this.state.financialContact || this.props.invoice?.financialContactId;
  }

  get emailContact() {
    return this.state.emailContact || this.props.invoice?.emailContact;
  }

  get emailTo() {
    return this.state.emailToChanged ? this.state.emailTo : this.props.invoice?.emailTo;
  }
  get onCompleteDisabled() {
    // return !this.emailContact && !this.emailTo;
    return !this.emailContact;
  }

  onComplete() {
    const dto = {
      financialContactId: this.financialContact ?? null,
      emailContactId: this.emailContact?.id ?? null,
      emailTo: this.emailTo ?? null,
    };

    this.props.onComplete(dto, result => {});
  }

  onClose() {
    this.props.onClose();
  }

  onChangedEmailTo(evt) {
    this.setState({ emailTo: evt.target.value, emailToChanged: true });
  }

  renderAddUser() {
    if (!this.state.selectUser) return null;
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('company.users.delete.confirm.title')}>
        {this.state.addUser?.id ? (
          <VBox>{this.state.addUser?.email_address}</VBox>
        ) : (
          <UserSelection onSelect={user => this.setState({ addUser: user })} />
        )}
        <div className="d-flex gap-2 mt-4">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={!this.state.addUser?.id}
            onClick={() => this.selectUser(this.state.addUser)}
          >
            {this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    if (this.props.invoice?.direction === INVOICE_DIRECTIONS.INCOMING && (this.props.busy || this.props.sending))
      return <Loader />;
    const targetCompanyId =
      this.props.invoice?.direction === INVOICE_DIRECTIONS.OUTGOING
        ? this.props.invoice?.outgoingCompanyId
        : this.props.invoice?.incomingCompanyId;

    const targetCompany =
      this.props.invoice?.direction === INVOICE_DIRECTIONS.OUTGOING
        ? this.props.invoice?.outgoingCompany
        : this.props.invoice?.incomingCompany;

    return (
      <VBox left>
        {this.renderAddUser()}
        <WithCompany companyId={targetCompanyId} loader>
          <Well>
            <CompanyLabel company={targetCompany} />
          </Well>

          <>
            <VBox>
              <span style={{ marginBottom: '5px', fontWeight: '400' }}>
                {this.lbl(`vehicle.order.property.financial_contact`)}
              </span>

              <div style={{ display: 'flex', marginBottom: '24px ' }}>
                {this.props.work ? (
                  <Loader small />
                ) : (
                  <div className={styles.VehicleCreateFieldCompanyUser}>
                    <VehicleCreateFieldCompanyUser
                      financialContact={true}
                      includeFinancialContact={'1'}
                      order
                      title={'financial contact'}
                      companyId={this.invoice?.outgoingCompanyId}
                      key={`${'financial_contact'}-${this.invoice?.outgoingCompanyId}`}
                      editedValue={this.financialContact}
                      onChange={value => this.setState({ financialContact: value })}
                    />
                  </div>
                )}
              </div>

              <span style={{ marginBottom: '5px', fontWeight: '400' }}>
                {this.lbl(`vehicle.order.property.send_to_email`)}
              </span>

              <div className={styles.container}>
                <div className={styles.nameUser}>
                  <UserLabelById order user_id={this.emailContact?.id} key={this.emailContact?.id} />
                </div>
                <div className={styles.button}>
                  <ButtonComponent style={'ButtonSoftEdit'} onClick={() => this.setState({ selectUser: true })}>
                    <EditSquare />
                  </ButtonComponent>
                </div>
              </div>
            </VBox>

            <label className="form-label">Email</label>
            <input
              className="form-control"
              type="email"
              style={{ width: 'auto' }}
              value={this.emailTo ?? ''}
              onChange={this.onChangedEmailTo.bind(this)}
            />
          </>
          <div className="mt-2">
            <ButtonComponent
              style={'ButtonSoftEdit'}
              disabled={!this.financialContact || this.props.work}
              onClick={this.onComplete.bind(this)}
            >
              {this.lbl('confirm')}
            </ButtonComponent>
          </div>
        </WithCompany>
      </VBox>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_USER),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchUser(id, callback) {
      dispatch(fetchUser(id, callback));
    },

    onComplete(dto, callback) {
      dispatch(updateInvoice(ownProps?.invoice?.id, dto, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UpdateInvoiceEmailModal = compose(withConnect, withRouter)(UpdateInvoiceEmailModalComp);
